/* unplugin-vue-components disabled */import script from "./HandleAlarm.vue?vue&type=script&setup=true&lang=ts"
export * from "./HandleAlarm.vue?vue&type=script&setup=true&lang=ts"

import "./HandleAlarm.vue?vue&type=style&index=0&id=61194b76&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61194b76"]])

export default __exports__